import { classNames } from "@components/library/utils/classNames";
import { EmailForm } from "./EmailForm";

export const CTASection = ({
  className,
}: React.PropsWithChildren<{ className?: string }>) => {
  return (
    <div
      className={classNames(
        "container-lg mx-auto flex flex-col gap-4 py-48 text-center md:gap-12 md:py-160 md:pl-64 "
      )}
    >
      <h4 className="mb-16 text-16-24 font-bold text-blue-600  dark:text-white ">
        Sign up
      </h4>
      <h4 className="mb-24 font-display text-24-28 font-bold tracking-wide text-black dark:text-white md:mb-40 md:text-[56px] md:font-normal md:leading-[64px]">
        Getting from{" "}
        <span className="rounded-lg bg-blue-200 px-6 pt-2">
          Playground to Profit
        </span>{" "}
        has never been this intuitive
      </h4>
      <div className="mx-auto flex">
        <EmailForm />
      </div>
    </div>
  );
};
